import { z } from 'zod';
import { requireFields, yesNo, yesNoUnknownRequired } from '@utils/form-schema';

// YesNoUnknown.Yes === 1 (drives the treatment sub-questions).
const YES = '1';

export const assessNutcrackerSchema = z
    .object({
        hasNutcracker: yesNoUnknownRequired,
        wasNutcrackerTreated: yesNo,
        nutcrackerTreatment: z.string(),
    })
    .superRefine((data, ctx) => {
        if (data.hasNutcracker === YES) {
            requireFields(ctx, data, 'wasNutcrackerTreated');

            if (data.wasNutcrackerTreated === '1') {
                requireFields(ctx, data, 'nutcrackerTreatment');
            }
        }
    });
